import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import LoginGate from '../common/LoginGate'

/**
 * Wer welche Seite sieht (Kim, 13.09.2026):
 *   Besucher     Start mit Ausschnitt, Glossar, Rechtliches
 *   angemeldet   dazu Screener, Top-Ideen, Watchlist
 *   Admin        dazu Importe, Systemstatus, Rückvergleich, Größen-Split, alte Seiten
 *
 * Das regelt die Sicht, nicht die Sicherheit: Die Daten dahinter gibt das
 * Backend nur mit passender Anmeldung heraus.
 */
export function NurAngemeldet({ titel, children }: { titel: string; children: ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth()
  if (isLoading) return null
  if (!isAuthenticated) {
    return (
      <div className="q-page">
        <section className="q-card">
          <LoginGate titel={titel} zeilen={6} />
        </section>
      </div>
    )
  }
  return <>{children}</>
}

/** Admin-Seiten gibt es fuer alle anderen nicht -- auch kein Hinweis, dass sie existieren. */
export function NurAdmin({ children }: { children: ReactNode }) {
  const { isAdmin, isLoading } = useAuth()
  if (isLoading) return null
  if (!isAdmin) return <NichtGefunden />
  return <>{children}</>
}

export function NichtGefunden() {
  return (
    <div className="q-page">
      <section className="q-card">
        <div className="q-state">
          <span className="q-state-code">404</span>
          <span>Diese Seite gibt es nicht.</span>
          <Link to="/" className="q-btn q-btn-ghost q-btn-sm">
            Zur Startseite
          </Link>
        </div>
      </section>
    </div>
  )
}
